import { PhotoDisplayHandler } from "components";
import "./BanerCard.scss";

const BanerCard = ({
  title,
  description,
  picture,
  device,
  orientation,
  url,
  seo_keywords,
}: any) => {
  return (
    <a
      href={url}
      target="_blank"
      title={`Vidi detaljno ${title}`}
      rel="noopener noreferrer"
      className="Baner-Card"
    >
      <div className="Baner-Image">
        <PhotoDisplayHandler
          img_name={picture}
          calculate={false}
          img_class_name=""
          img_alt={title}
          width="100%"
          height="auto"
        />
      </div>
      <div className="Baner-Text">
        <label className="Baner-Text-Title">{title}</label>
        <label className="Baner-Text-Description">{description}</label>
      </div>
    </a>
  );
};

export default BanerCard;
